export enum PendingSwapsListType {
    Recipient = 1,
    Donor = 2,
    Internal = 3,
    Remote = 4
}